import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Checkbox, ErrorBox, PageHeader, Select } from '../Components';
import { H4, Input, List, Row } from '../Components/H1';
import { COLORS, commonStyle } from '../config';
import { userGet, userPut, newPasswordPost, userSettingsPut } from '../API';
import { message } from '../Components/Notify';
import {useHistory} from "react-router-dom";

const IconEdit = styled.span`
  font-size: 12px;
  background-color: ${COLORS.classic};
  padding: 8px;
  border-radius: 50%;
  margin-top: -12px;
  cursor: pointer;
  width: 14px;
  height: 14px;
`;

const EditInput = styled.input`
  font-size: 15px;
  color: ${COLORS.primary};
  width: 100%;
  outline: none;
  background-color: transparent;
  border: none;
  font-weight: 700;
  padding-bottom: 2px;
`;

const Block = styled.div`
  border-radius: ${commonStyle.borderRadius}px;
  padding: 8px;
  background-color: ${COLORS.classic};
  margin-bottom: 16px;
`;

const Compte = ({ user, updateUser, disconnect }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [editInput, setEditInput] = useState('');
  const [editing, setEditing] = useState(null);
  const [error, setError] = useState(null);
  const [newPrefComm, setNewPrefComm] = useState(null);
  const [newInfoComm, setNewInfoComm] = useState(null);
  const [newInfoProg, setNewInfoProg] = useState(null);
  const history = useHistory();

  const inputRef = React.createRef();

  useEffect(() => {
    if (user) syncUser();
  }, []);

  const syncUser = async () => {
    try {
      const m_user = await userGet(user);
      updateUser(m_user);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    // FIXME : Post new password to backend
    try {
      const userUpdated = await newPasswordPost({
        userId: user.id,
        oldPassword,
        newPassword,
      });
      setError(null);
      message.success('Mise à jour réussie');
      setOldPassword('');
      setNewPassword('');
    } catch (error) {
      console.error(error);
      setError(
        error.status === 400 ? 'Mauvais mot de passe' : 'Erreur de mise à jour'
      );
    }
  };

  const handleEdit = async (s) => {
    try {
      if (editing === s) {
        setEditing(null);
        const m_user = await userPut({ user, data: { [s]: editInput } });
        if (m_user) await syncUser();
      } else {
        setEditing(s);
        setEditInput(user[s] || '');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const updatePrefs = async () => {
    try {
      if (newInfoComm === null && newInfoProg === null && newPrefComm === null)
        return;
      const newSettings = {
        infoComm:
          typeof newInfoComm === 'boolean'
            ? newInfoComm
            : user.settings.infoComm,
        infoProg:
          typeof newInfoProg === 'boolean'
            ? newInfoProg
            : user.settings.infoProg,
        prefComm: newPrefComm ? newPrefComm : user.settings.prefComm,
      };
      const update = await userSettingsPut({
        settingsId: user.userSettingId,
        settings: newSettings,
      });
      updateUser({ ...user, settings: newSettings });
      setNewInfoComm(null);
      setNewInfoProg(null);
      setNewPrefComm(null);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, [inputRef]);

  return (
    <>
      <PageHeader style="{{ marginBottom: 40 }}" title={'Votre compte'} />
      
      <br />
      
      <Block style={{ paddingTop: 14, paddingBottom: 14 }}>
	      <List>
	        <List.Item label={'Nom :'}>
	          <H4>{user?.lastname || 'N/C'}</H4>
	        </List.Item>
	        <List.Item label={'Prénom :'}>
	          <H4>{user?.firstname || 'N/C'}</H4>
	        </List.Item>
	        <List.Item label={'Date de naissance :'}>
	          <H4>{user?.birthdate || 'N/C'}</H4>
	        </List.Item>
	        <List.Item label={'Email :'}>
	          <H4>{user?.email}</H4>
	        </List.Item>
	        <List.Item label={'Téléphone :'}>
	          <H4>{user?.phone || 'N/C'}</H4>
	        </List.Item>
	        <List.Item style={{ border: 0 }} label={'Adresse :'}>
	          <H4>{user?.address || 'N/C'}</H4>
	        </List.Item>
	      </List>
	    </Block>
	     
      {user?.coacquirer_email != undefined && (
      	<>
      		<Block style={{ paddingTop: 14, paddingBottom: 14 }}>
			      <H4 style={{ margin: 8, color: COLORS.classic }}> Co-acquéreur :</H4>
			      <List>
			        <List.Item label={'Nom :'}>
			          <H4>{user?.coacquirer_lastname || 'N/C'}</H4>
			        </List.Item>
			        <List.Item label={'Prénom :'}>
			          <H4>{user?.coacquirer_firstname || 'N/C'}</H4>
			        </List.Item>
			        <List.Item label={'Email :'}>
			          <H4>{user?.coacquirer_email}</H4>
			        </List.Item>
			        <List.Item label={'Téléphone :'}>
			          <H4>{user?.coacquirer_phone || 'N/C'}</H4>
			        </List.Item>
			        <List.Item style={{ border: 0 }} label={'Adresse :'}>
			          <H4>{user?.coacquirer_address || 'N/C'}</H4>
			        </List.Item>
			      </List>
			     </Block>
		    </>
		  )}
      
      <Block style={{ paddingTop: 24, paddingBottom: 24 }}>
        <H4 style={{ marginLeft: 8 }}>
          Vous souhaitez changer votre mot de passe :{' '}
        </H4>
        <form>
          <div style={{ margin: 16 }}>
            <span style={{ marginLeft: 16, fontSize: 12 }}>
              Ancien mot de passe :{' '}
            </span>
            <br />
            <Input
              type='password'
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              style={{
                backgroundColor: COLORS.background,
                color: COLORS.primary,
                marginLeft: 0,
                width: 'calc(100% - 28px)',
              }}
              placeholder='Ancien ...'
            ></Input>
            <br />
            <span style={{ marginLeft: 16, fontSize: 12 }}>
              Nouveau mot de passe :{' '}
            </span>
            <br />
            <Input
              type='password'
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              style={{
                backgroundColor: COLORS.background,
                color: COLORS.primary,
                marginLeft: 0,
                width: 'calc(100% - 28px)',
              }}
              placeholder='Nouveau ...'
            ></Input>
          </div>
          <ErrorBox error={error} />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              type='submit'
              primary
              onClick={handleSave}
              disabled={!oldPassword || !newPassword}
            >
              Enregistrer
            </Button>
          </div>
        </form>
      </Block>
      <Button
          style={{
            padding: '8px 32px',
            margin:'auto',
            display:'flex'
          }}
          onClick={() => {
            disconnect();
            history.push('/');
          }}
      >
        <span
            className={`icon-dbi-pic-_Disconnect`}
            style={{
              fontSize: 24,
              marginRight: 16,
            }}
        />
        Déconnexion
      </Button>
    </>
  );
};

export { Compte };
